import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { MenuSharedFacade, SlideViewerFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-slide-sidebar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './slide-sidebar.component.html',
    styleUrls: ['./slide-sidebar.component.scss'],
    standalone: false
})
export class SlideSidebarComponent {
  /**
   * Constructor
   *
   * @param slideViewerFacade
   * @param menuSharedFacade
   */
  public constructor(public slideViewerFacade: SlideViewerFacade, 
                    public elRef: ElementRef,
                    public menuSharedFacade: MenuSharedFacade) {
  }
}
